import * as filtersService from '@/legacy/services/filters/filtersService';
import * as paginationService from '@/legacy/services/pagination';

export class ViewModelParams {
  public options: filtersService.FilterOptions;

  public pagination: paginationService.PaginationKnockoutModel;

  public basicPagination = false;
}
export class ViewModel {
  public options: filtersService.FilterOptions;

  public pagination: paginationService.PaginationKnockoutModel;

  public basicPagination = false;

  public activate(params: ViewModelParams) {
    this.options = params.options;
    this.pagination = params.pagination;

    if (params.basicPagination !== undefined) {
      this.basicPagination = params.basicPagination;
    }
  }

  public navigatePage(newPageNumber: number) {
    this.pagination.navigatePage(newPageNumber);
  }
}
